import React from "react";
import PropTypes from "prop-types";
import Errors from "@morningtrain/react-errors";
import TemplateManagerContext from "../contexts/TemplateManagerContext";
import RenderCurrentTemplate from "./RenderCurrentTemplate";
import {useEventListeners} from "@morningtrain/react-helpers";
import useApp from "../hooks/use-app";

function TemplateManager(props) {

    const app = useApp();

    const defaultTemplate = props.defaultTemplate;
    const currentTemplate = null;

    const [triggerTemplateChange, onTemplateChange, removeOnTemplateChangeListener] = useEventListeners();

    const isTemplate = (template) => {
        return manager.currentTemplate === template;
    };

    const changeTemplate = (template) => {
        manager.currentTemplate = template;
        triggerTemplateChange(template);
    };

    const manager = {
        currentTemplate: currentTemplate,
        defaultTemplate: defaultTemplate,
        isTemplate: isTemplate,
        changeTemplate: changeTemplate,
        onTemplateChange: onTemplateChange,
        removeOnTemplateChangeListener: removeOnTemplateChangeListener,
        templates: app.templates(),
    };

    return (
        <TemplateManagerContext.Provider value={manager}>
            <RenderCurrentTemplate>
                <Errors.Boundary>
                    {props.children}
                </Errors.Boundary>
            </RenderCurrentTemplate>
        </TemplateManagerContext.Provider>
    );
}

TemplateManager.defaultProps = {
    defaultTemplate: null,
}

TemplateManager.propTypes = {
    defaultTemplate: PropTypes.string,
}

export default TemplateManager;
